/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const accountTypePostRequestSchema = z.object({
  value: z.string(),
});
